export const ConfigInfotoolsActionTypes = {
  API_RESPONSE_SUCCESS: '@@config-infotools/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@config-infotools/API_RESPONSE_ERROR',

  GET_CONFIG_INFOTOOLS: '@@config-infotools/GET_CONFIG_INFOTOOLS',
  LIST_CONFIGS_INFOTOOLS: '@@config-infotools/LIST_CONFIGS_INFOTOOLS',
  ADD_CONFIG_INFOTOOLS: '@@config-infotools/ADD_CONFIG_INFOTOOLS',
  UPDATE_CONFIG_INFOTOOLS: '@@config-infotools/UPDATE_CONFIG_INFOTOOLS',
  DELETE_CONFIG_INFOTOOLS: '@@config-infotools/DELETE_CONFIG_INFOTOOLS',

  RESET: '@@config-infotools/RESET'
}
